import { CareerQuestion, CareerUserResponseSet, CareerUserResponseAnswer } from '../models/models';

export function getQuestionByTitle(
  questions: CareerQuestion[],
  title: string,
): CareerQuestion | undefined {
  return questions.find((question) => question.title === title);
}

export function getQuestionByKey(
  questions: CareerQuestion[],
  calculator_key: string,
): CareerQuestion | undefined {
  return questions.find((question) => question.calculator_key === calculator_key);
}

export function getUserResponse(
  responseSet: CareerUserResponseSet,
  questionId: number,
): CareerUserResponseAnswer | undefined {
  return responseSet.user_responses.find((response) => response.career_question_id === questionId);
}

export function didUserSelectOptionWithAnswer(
  response: CareerUserResponseAnswer,
  question: CareerQuestion,
  answerText: string,
): boolean {
  const selectedOptionIds = new Set(response.career_question_option_ids);

  return question.options.some(
    (option) => selectedOptionIds.has(option.id) && option.answer === answerText,
  );
}

export function didUserSelectOptionWithAnswerByKey({
  response,
  question,
  answerText,
}: {
  response: CareerUserResponseAnswer;
  question: CareerQuestion;
  answerText: string;
}): boolean {
  const selectedOptionIds = new Set(response.career_question_option_ids);

  return question.options.some(
    (option) => selectedOptionIds.has(option.id) && option.calculator_key === answerText,
  );
}

export function didUserSelectAnyOptionWithAnswers(
  response: CareerUserResponseAnswer,
  question: CareerQuestion,
  answerTexts: string[],
): boolean {
  const selectedOptionIds = new Set(response.career_question_option_ids);
  const answerTextSet = new Set(answerTexts);

  return question.options.some(
    (option) => selectedOptionIds.has(option.id) && answerTextSet.has(option.answer),
  );
}

export function didUserSelectAnyOptionWithAnswersByKey({
  response,
  question,
  answerTexts,
}: {
  response: CareerUserResponseAnswer;
  question: CareerQuestion;
  answerTexts: string[];
}): boolean {
  const selectedOptionIds = new Set(response.career_question_option_ids);
  const answerTextSet = new Set(answerTexts);

  return question.options.some(
    (option) => selectedOptionIds.has(option.id) && answerTextSet.has(option.calculator_key),
  );
}
